<template>
  <div>
    <v-card flat class="rounded-card">
      <v-card-title>ドライバーステータス</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-select
              v-model="driver_status"
              dense
              outlined
              rounded
              hide-details="auto"
              :items="driver_statuses"
              persistent-placeholder
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text
        v-if="drivers === null"
        style="height: 35vh;overflow-y: scroll;"
      >
        <v-skeleton-loader
          v-for="n in 4"
          :key="n"
          type="list-item-avatar"
          loading
          transition="fade-transition"
        />
      </v-card-text>
      <v-card-text
        v-else
        style="height: 35vh;overflow-y: scroll;"
      >
        <v-list
          v-for="driver in filteredDrivers"
          :key="driver.id"
          dense
        >
          <v-list-item dense>
            <v-list-item-content>
              <v-row dense>
                <v-col cols="2" sm="3">
                  <v-layout justify-center>
                    <v-avatar
                      color="primary"
                      size="48"
                    >
                      <v-img
                        v-if="driver.avatar"
                        :src="driver.avatar"
                      />
                      <span
                        v-else
                        class="primary white--text"
                      >
                        {{ driver.name.slice(0, 2) }}
                      </span>
                    </v-avatar>
                  </v-layout>
                </v-col>
                <v-col cols="10" sm="9">
                  <step-progress-slider
                    :step-count="driver.step"
                  />
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import StepProgressSlider from '../../../components/StepProgressSlider'
import {mapActions} from "vuex";
export default {
  name: 'DashboardWorkStatus',
  components: {
    StepProgressSlider
  },
  mixins: [],
  props: {
    targetDate: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      driver_status: 0,
      driver_statuses: [
        { value: 0, text: '全て' },
        { value: 2, text: '運搬中' },
        { value: 3, text: '完了' }],
      drivers: null,
    }
  },
  computed: {
    filteredDrivers () {
      let filteredList = []
      for (const driver of this.drivers) {
        if (this.driver_status === 0) {
          filteredList.push(driver)
        } else {
          if (driver.step === this.driver_status) {
            filteredList.push(driver)
          }
        }
      }
      return filteredList
    },
  },
  watch: {},
  created() {
    this.fetchDrivers().then((content) => {
      this.drivers = content.drivers
      for (const driver of this.drivers) {
        this.fetchStatus({driver_id: driver.id, target_date: this.targetDate}).then((content) => {
          driver.step = content.step
        })

      }
    })
  },
  methods: {
    ...mapActions('DriverDashboardDriver', {
      fetchDrivers: 'index',
    }),
    ...mapActions('DriverDashboardDriverStatus', {
      fetchStatus: 'show'
    }),
  }
}
</script>

<style scoped lang="scss">
.v-skeleton-loader {
  height: 70px;
}
</style>
